import { IItemPlanDto } from "@kuika/kuika-cl-model";
import { FormInstance } from "antd/es/form";
import * as React from "react";
import { SubscriptionService } from "../../../../services/subscription-service";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../../../shared/hoc/with-history";
import { withManagement } from "../../../../shared/hoc/with-management";
import { KMainFunctions } from "../../../../shared/utility/main-functions";

export interface ISubscriptionChangeState {
  isDataLoading: boolean;
  plan: IItemPlanDto;
  isExpanded: boolean;
}

export interface ISubscriptionChangeProps {}

class SubscriptionChange extends React.PureComponent<
  ISubscriptionChangeProps & IWithContextProp & IWithHistoryProp,
  ISubscriptionChangeState
> {
  formRef = React.createRef<FormInstance>();

  constructor(props: ISubscriptionChangeProps & IWithContextProp & IWithHistoryProp) {
    super(props);

    this.state = {
      isDataLoading: false,
      plan: null as unknown as IItemPlanDto,
      isExpanded: false
    };
  }

  async componentDidMount() {
    const targetPlanId = KMainFunctions.getPlanIdFromUrl();
    this.loadTargetPlan(targetPlanId);
  }

  async loadTargetPlan(targetPlanId) {
    this.setState({ isDataLoading: true });
    try {
      const plan: IItemPlanDto = (await (await SubscriptionService.LoadPlan(targetPlanId)).data) as IItemPlanDto;
      this.setState({ plan, isDataLoading: false });
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      this.setState({ isDataLoading: false });
    }
  }

  toggleIsExpanded() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  render() {
    return (
      <>
        {this.state.plan && (
          <div style={{ width: 1040, margin: "auto" }}>
            <label style={{ color: "var(--dark)", fontWeight: 500, fontSize: 20 }}>
              Get Started with {this.state.plan.planName} Plan
            </label>

            <div style={{ display: "flex", flexDirection: "row", marginTop: 12 }}>
              <div style={{ display: "flex", flexDirection: "column", flexBasis: "60%", marginRight: 40 }}>
                <div
                  style={{
                    borderRadius: "var(--radius-l)",
                    backgroundColor: "var(--callout-blue-fill)",
                    // The tint darkens in the dark theme; the text has to follow it or it is lost.
                    color: "var(--dark)",
                    padding: 16
                  }}
                >
                  <label style={{ fontWeight: 600 }}>
                    Start your 14 day, no-cost {this.state.plan.planName} trial today
                  </label>
                  <br />
                  <label>You’ll be charged the Standard monthly cost when your trial ends on Nov 26, 2021.</label>
                </div>

                <div
                  style={{
                    borderRadius: "var(--radius-l)",
                    padding: 16,
                    border: "1px solid var(--dark-3)",
                    marginTop: 12
                  }}
                >
                  <label>Standard monthly cost</label>
                  {!this.state.isExpanded && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      role="presentation"
                      onClick={() => this.toggleIsExpanded()}
                      style={{ float: "right", color: "rgb(0, 82, 204)" }}
                    >
                      <path
                        d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z"
                        fill="currentColor"
                        fillRule="evenodd"
                      ></path>
                    </svg>
                  )}
                  {this.state.isExpanded && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      role="presentation"
                      onClick={() => this.toggleIsExpanded()}
                      style={{ float: "right", color: "rgb(0, 82, 204)" }}
                    >
                      <path
                        d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z"
                        fill="currentColor"
                        fillRule="evenodd"
                      ></path>
                    </svg>
                  )}
                  <br />
                  <label>USD 55.00 (tax inclusive)</label>
                  <br />
                  You’re paying for 10 users. If you add or remove users, this amount will be recalculated. From Nov 26,
                  2021, we’ll first charge you a prorated amount for the period between the first day after your free
                  trial ends and the last day before your billing period starts. From Dec 3, 2021, we’ll charge you the
                  regular amount for your Standard plan subscription, using your current payment method.
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", flexBasis: "40%" }}></div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const plansPage = withContext<ISubscriptionChangeProps>(
  withManagement<ISubscriptionChangeProps>(withHistory<ISubscriptionChangeProps>(SubscriptionChange))
);
export { plansPage as SubscriptionChange };
